import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Edmunds(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#BA2E3E" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M14.5088 10.7966C14.5088 10.1954 14.32 9.67903 13.9423 9.24743C13.5647 8.81582 12.9982 8.60003 12.2429 8.60003C11.873 8.60003 11.5339 8.65783 11.2256 8.77344C10.9173 8.88904 10.6476 9.04704 10.4163 9.24743C10.1851 9.44781 10.0002 9.68288 9.86142 9.95263C9.72269 10.2224 9.64562 10.5037 9.63021 10.7966H14.5088ZM18 12.2532V12.7156C18 12.8698 17.9923 13.0162 17.9769 13.1549H9.63006C9.66089 13.4786 9.75722 13.7715 9.91908 14.0335C10.0809 14.2956 10.289 14.5229 10.5434 14.7156C10.7977 14.9083 11.0828 15.0586 11.3988 15.1665C11.7148 15.2744 12.0424 15.3283 12.3815 15.3283C12.9827 15.3283 13.4913 15.2166 13.9075 14.9931C14.3237 14.7696 14.6628 14.4806 14.9249 14.126L17.5607 15.7908C17.0212 16.5769 16.3083 17.1819 15.422 17.6058C14.5356 18.0297 13.5067 18.2416 12.3353 18.2416C11.4721 18.2416 10.6551 18.1068 9.88439 17.837C9.11368 17.5673 8.43931 17.1742 7.86127 16.6578C7.28323 16.1414 6.82852 15.5056 6.49711 14.7503C6.1657 13.995 6 13.1318 6 12.1607C6 11.2204 6.16185 10.3688 6.48555 9.6058C6.80925 8.84279 7.24855 8.1954 7.80347 7.6636C8.35838 7.13181 9.01348 6.71948 9.76879 6.42661C10.5241 6.13374 11.341 5.9873 12.2197 5.9873C13.0674 5.9873 13.8459 6.12989 14.5549 6.41505C15.264 6.70022 15.8728 7.11254 16.3815 7.65204C16.8902 8.19155 17.2871 8.84665 17.5723 9.61736C17.8574 10.3881 18 11.2667 18 12.2532Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

Edmunds.propTypes = propTypes;
Edmunds.defaultProps = defaultProps;

export default Edmunds;
